"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("@ahmdigital/constants");
var _default = exports["default"] = {
  getWebViewAccessToken: function getWebViewAccessToken() {
    var _cookies$WEB_VIEW_COO;
    var cookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (_cookies$WEB_VIEW_COO = cookies === null || cookies === void 0 ? void 0 : cookies[_constants.WEB_VIEW_COOKIE.WEB_VIEW_ACCESS_TOKEN]) !== null && _cookies$WEB_VIEW_COO !== void 0 ? _cookies$WEB_VIEW_COO : null;
  },
  isWebView: function isWebView() {
    var cookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (cookies === null || cookies === void 0 ? void 0 : cookies[_constants.WEB_VIEW_COOKIE.VIEW_MODE]) === _constants.VIEW_MODE.WEB_VIEW;
  }
};
module.exports = exports.default;